// Your JavaScript goes here
function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(() => {
    let popupViewed = 0;
    const popupCookieName = 'popupViewed';
    const exitPopup = document.getElementById('exit-popup');
    const exitPopupInner = document.getElementById('exit-popup-inner');
    const exitPopupClose = document.getElementById('exit-close-button');
    const exitPopupCloseBg = document.getElementById('exit-popup');

    // console.log(exitPopup);

    function setCookie(cookieName, cookieValue) {
        document.cookie = cookieName + "=" + cookieValue + "; path=/";
    }

    function getCookie(cName) {
        const name = cName + "=";
        const cDecoded = decodeURIComponent(document.cookie); //to be careful
        const cArr = cDecoded.split('; ');
        let res;
        cArr.forEach(val => {
            if (val.indexOf(name) === 0) res = val.substring(name.length);
        })
        return res;
    }

    function openPopup() {
        if (!parseInt(getCookie(popupCookieName), 10)) {
            popupViewed = 1;
            setCookie(popupCookieName, popupViewed);

            exitPopup.classList.remove('hidden');

            setTimeout(() => {
                exitPopup.classList.remove('opacity-0');
                exitPopupInner.classList.remove('opacity-0');
                exitPopup.classList.add('opacity-100');
                exitPopupInner.classList.add('opacity-100');

            }, 100)
        }
    }

    function closePopup() {
        exitPopupClose.addEventListener('click', e => {
            exitPopup.classList.add('hidden');
        });

        exitPopupCloseBg.addEventListener('click', e => {
            if (e.target === e.currentTarget) {
                exitPopup.classList.add('hidden');
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.keyCode == 27 || event.key === 'Esc' || event.key === 'Escape') {
                exitPopup.classList.add('hidden');
            }
        });
    }

    setCookie(popupCookieName, popupViewed);


    if (window.innerWidth < 760) {
        setTimeout(() => {
            openPopup()
        }, 30000);
    } else {
        document.addEventListener('mouseleave', e => {
            openPopup()
        });
    }

    closePopup();

})





